import { OC_B_ORDER } from '@/js/pages/orderCenter/returngood/config';
Vue.component('SD', () => import('allpages/orderCenter/orderManageDetail/details/SD.vue'));

export default {
  data() {
    return {
      tableItemUrl: '/p/cs/objectTableItem',
      tableConfig: {
        columns: [],
        data: [],
        pageShow: true, // 控制分页是否显示
        btnsShow: true, // 控制操作按钮是否显示
        searchInputShow: false, // 控制搜索框是否显示
        indexColumn: false,
        width: '', // 表格宽度
        height: '', // 表格高度
        border: true, // 是否显示纵向边框
        total: 0, // 设置总条数
        pageSizeOpts: [10, 20, 30], // 每页条数切换的配置
        pageSize: 10, // 每页条数
        current: 1, // 当前页
        loading: true
      },
      objid: '',
      options: {}, // 自定义属性（选填）
      isAbnormal: false // 是否异常商品
    };
  },
  props: {
    componentData: {}
  },
  watch: {
    componentData: {
      handler(newVal, oldVal) {
        this.request(newVal, true);
      },
    }
  },
  methods: {
    pageChange(val) {
      this.tableConfig.current = val;
      this.request(this.componentData);
    },
    pageSizeChange(val) {
      this.tableConfig.pageSize = val;
      this.request(this.componentData);
    },
    initTable() {
      this.tableConfig.current = 1
      this.tableConfig.total = 0
      /* 重置表头及数据，会有空白时间，不友好
      this.tableConfig.data = []
      this.tableConfig.columns = [] */
    },
    async request(req, isInit) {
      const self = this;
      const data = req.hasOwnProperty('ref') ? req.ref : JSON.parse(JSON.stringify(OC_B_ORDER[req.tablename]));
      self.objid = req.objid || -1;
      if (!req.isNew && self.objid === -1) return; // isNew: true 场景：新增页面获取子表
      // data.objid = self.objid ;
      isInit && this.initTable()
      this.tableConfig.loading = true
      const searchdata = {};
      searchdata.startindex = (this.tableConfig.current - 1) * this.tableConfig.pageSize;
      searchdata.range = this.tableConfig.pageSize;
      data.searchdata = Object.assign(data.searchdata, searchdata);
      self.options = req.options || {};
      // objectTableItem
      
      let res
      if (this.$route.params.tableName == 'OC_B_VIPCOM_RETURN_PO' ) {
        // 唯品会退货单-条码明细
        data.searchdata.fixedcolumns = { SKU_FILTER_TYPE: this.isAbnormal ? 'ERR' : 'ALL' }
        const formdata = {
          objid: self.objid,
          table: data.table,
          searchdata: data.searchdata,
          refcolid: data.refcolid
        }
        res = await this.service.orderCenter.querySkuList(formdata)
      } else if (['OC_B_ORDER_PROMOTION', 'OC_B_ORDER_PAYMENT', 'OC_B_ORDER_GIFT_CARD'].includes(this.componentData.tablename)) {
        // 零售详情-优惠信息\支付信息
        let api
        switch (this.componentData.tablename) {
          case 'OC_B_ORDER_GIFT_CARD':
            api = 'selectGiftCard'
            break;
          case 'OC_B_ORDER_PROMOTION':
            api = 'selectPromotion'
            break;
          case 'OC_B_ORDER_PAYMENT':
            api = 'selectPayment'
            break;
          case 'PS_C_PRO_GROUP_LOG':
            api = 'productLog'
            break;
          default:
            break;
        }
        const formdata = {
          objid: self.objid,
          table: data.table,
          searchdata: data.searchdata,
          refcolid: data.refcolid
        }
        res = await this.service.common[api](formdata);
      } else if (['PS_C_PRO_GROUP_LOG'].includes(this.componentData.tablename)) {
        /**
         * 组合商品操作日志
         * 调整成分品数量、占比、组合SPU的“可用”，组合条码的“可用”，删除成分品、组合商品的“是否允许拆单”都需要记录操作日志
         */
        const formdata = new FormData();
        data.searchdata = {
          objid: self.objid,
          table: data.table,
          refcolid: data.refcolid,
          mainTableName: 'PS_C_PRO_GROUP',
          startindex: data.searchdata.startindex,
          range: data.searchdata.range,
          column_include_uicontroller: true
        }
        formdata.append('searchdata', JSON.stringify(data.searchdata));
        res = await this.service.common.productLog(formdata);
      } else {
        const formdata = new FormData();
        formdata.append('objid', self.objid);
        formdata.append('table', data.table);
        formdata.append('searchdata', JSON.stringify(data.searchdata));
        formdata.append('refcolid', data.refcolid);
        res = await this.service.common.objectTableItem(formdata);
      }
      this.tableConfig.loading = false
      if (res.data.code === 0) {
        if (res.data.datas.tabname == 'OC_B_ORDER_GIFT_CARD') {
          res.data.datas.tabth.push(
            {
              "issubtotal": false,
              "agfilter": "LIST",
              "orderno": 70,
              "isak": false,
              "display": "text",
              "length": 200,
              "type": "STRING",
              "datelimit": "all",
              "isagfilter": false,
              "isfilter": false,
              "colname": "ACTION",
              "isuppercase": false,
              "isnotnull": false,
              "ismodify": false,
              "name": t("操作"),
              "inputname": "ACTION"
            }
          )
        }
        self.showTable(res.data.datas);
        self.$emit('reset-table')
      } else {
        console.log('数据加载失败');
      }
      // const { data: { code, datas } } = await this.service.orderCenter.batchAddGoods(param);
      // if (code === 0) {
      //   self.showTable(datas);
      // } else {
      //   // 数据加载失败
      //   console.log(self.t('失败！'));
      // }
    },
    showTable(obj) {
      const tabname = obj.tabname;
      const thead = obj.tabth.filter((element) => {
        if (element.colname === 'ID') return false;
        return true;
      }).map((element) => {
        const obj = {
          key: element.colname,
          title: element.name
        };
        if (tabname == 'OC_B_ORDER_PAYMENT') {// 零售详情-支付信息
          if (element.colname == "EXCHANGE_MEMO") { // 水单
            obj.width = 250
            obj.render = (h, params) => {
              let imgs = []
              const INIT_EXCHANGE_MEMO = {}
              // 写死水单1~6
              new Array(6).fill(0).forEach((i, index) => (INIT_EXCHANGE_MEMO[`水单${index+1}`]=''))
              const curV = params.row.EXCHANGE_MEMO ? JSON.parse(params.row.EXCHANGE_MEMO) : {}
              Object.keys(INIT_EXCHANGE_MEMO).forEach(key => {
                imgs.push({ name: key, url: curV.hasOwnProperty(key) ? curV[key] : '' })
              })
              let orderStatus = $('.orderManageDetails')[0].__vue__.orderStatus || ''
              return h('div', {
                  style: {
                    height: '200px',
                    overflow: 'auto'
                  },
                }, [
                  h('SD', {
                    props: {
                      orderStatus,
                      row: params.row,
                      imgs
                    },
                    on: {
                      refresh: () => this.request(this.componentData)
                    }
                  })
                ])
            }
          }
        }
        return obj;
      });
      if (tabname == 'OC_B_ORDER_GIFT_CARD' && (obj.row && obj.row.length)) {
        $('#LpBtnVm').css('display', 'none')
      }
      const tbody = (obj.row || []).map((row) => {
        const obj = {};
        for (const i in row) {
          obj[i] = row[i].val;
          if (row[i].isfk) { // 外键关联
            let fk = { pid: row[i].refobjid, valuedata: row[i].val }
            obj.fk ? (obj.fk[i] = fk) : (obj.fk = { [i]: fk })
          }
        }
        return obj;
      });
      this.tableConfig = {
        columns: thead,
        data: tbody,
        pageShow: true, // 控制分页是否显示
        btnsShow: true, // 控制操作按钮是否显示
        searchInputShow: false, // 控制搜索框是否显示
        indexColumn: true,
        width: '', // 表格宽度
        height: '', // 表格高度
        border: true, // 是否显示纵向边框
        total: obj.totalRowCount, // 设置总条数
        pageSizeOpts: obj.selectrange, // 每页条数切换的配置
        pageSize: obj.defaultrange, // 每页条数
        current: this.tableConfig.current,
      };
      
      if (this.componentData.tableConfig) {
        this.tableConfig = { ...this.tableConfig, ...this.componentData.tableConfig }
      }
      
      if (obj.isSubTotalEnabled || obj.isFullRangeSubTotalEnabled) { // 合计、总计
        this.tableConfig.totalData = []
        if (obj.isSubTotalEnabled) { // 合计
          this.tableConfig.totalData.push([{ index: t('合计'), ...obj.subtotalRow}])
        }
        if (obj.isFullRangeSubTotalEnabled) {
          this.tableConfig.totalData.push([{ index: t('总计'), ...obj.fullRangeSubTotalRow}])
        }
      }
      
      if (this.$route.params.tableName == 'OC_B_VIPCOM_RETURN_PO') {
        this.tableConfig = {
          ...this.tableConfig,
          isShowSelection: true,
          selectedData: []
        }
      }
    },
    // 选中某一项时触发
    onSelect(selection, row) {
      this.tableConfig.selectedData = selection
    },
    // 取消选中某一项时触发
    onSelectCancel(selection, row) {
      this.tableConfig.selectedData = selection
    },
    // 点击全选时触发
    onSelectAll(selection) {
      this.tableConfig.selectedData = selection
    },
    // 点击取消全选时触发
    onSelectAllCancel(selection) {
      this.tableConfig.selectedData = selection
    },
    refresh(isAbnormal) {
      this.isAbnormal = isAbnormal
      this.request(this.componentData, null)
    }
  },
  mounted() {
    if (this.componentData && this.componentData.tablename) {
      this.request(this.componentData);
    }
  }
};
